import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { homeGuard } from './guards/home.guard';

export const routes: Routes = [
  {
    path: 'globe',
    loadComponent: () => import('./components/globe/globe.component').then(m => m.GlobeComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'globe',
    loadComponent: () => import('./components/globe/globe.component').then(m => m.GlobeComponent)
  },
  {
    path: 'org-selection',
    loadComponent: () => import('./components/org-selection/org-selection.component').then(m => m.OrgSelectionComponent),
    canActivate: [authGuard]
  },
  {
    path: 'track/:bookingId',
    loadComponent: () => import('./components/trip-tracking/trip-tracking.component').then(m => m.TripTrackingComponent),
    canActivate: [authGuard]
  },
  {
    path: '',
    loadComponent: () => import('./components/layout/layout.component').then(m => m.LayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'users',
        loadComponent: () => import('./components/users/users.component').then(m => m.UsersComponent)
      },
      {
        path: 'stops',
        loadComponent: () => import('./components/stops/stops.component').then(m => m.StopsComponent)
      },
      {
        path: 'routes',
        loadComponent: () => import('./components/routes/routes.component').then(m => m.RoutesComponent)
      },
      {
        path: 'vehicles',
        loadComponent: () => import('./components/vehicles/vehicles.component').then(m => m.VehiclesComponent)
      },
      {
        path: 'drivers',
        loadComponent: () => import('./components/drivers/drivers.component').then(m => m.DriversComponent)
      },
      {
        path: 'driver-duty',
        loadComponent: () => import('./components/driver-duty/driver-duty.component').then(m => m.DriverDutyComponent)
      },
      {
        path: 'booking',
        loadComponent: () => import('./components/booking/booking.component').then(m => m.BookingComponent)
      },
      {
        path: 'trip-history',
        loadComponent: () => import('./components/trip-history/trip-history.component').then(m => m.TripHistoryComponent)
      },
      {
        path: 'analytics',
        loadComponent: () => import('./components/analytics/analytics.component').then(m => m.AnalyticsComponent)
      },
      {
        path: 'operations',
        loadComponent: () => import('./components/operations/operations.component').then(m => m.OperationsComponent)
      },
      {
        path: 'organizations',
        loadComponent: () => import('./components/organizations/organizations.component').then(m => m.OrganizationsComponent)
      },
      {
        path: 'audit',
        loadComponent: () => import('./components/audit/audit.component').then(m => m.AuditComponent)
      },
      {
        path: 'profile',
        loadComponent: () => import('./components/profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: '',
        canActivate: [homeGuard],
        children: []
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
